import { Button, Card, Col, Form, Row } from 'antd';
import { useState } from 'react';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import { ExpensesServices } from '@gtpl/shared-services/finance';

import { Link, useHistory } from 'react-router-dom';

import React from 'react';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Excel } from 'antd-table-saveas-excel';
import { FileExcelFilled } from '@ant-design/icons';
import { ExpensesModelDtoReq } from '@gtpl/shared-models/finance';

export const FinanceExpenses = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [form] = Form.useForm();
  const [data, setData] = useState();
  const [columns, setColumns] = useState([]);
  const [values, setValues] = useState([]);
  const service = new ExpensesServices();
  const [loading, setLoading] = useState(false);
  const [] = useState(null);
  const history = useHistory();
  const plantId = JSON.parse(localStorage.getItem('unit_id'))
  console.log(plantId,"plantid")

 
  const expenseArray = [
    {"category":"EXTRAORDINARY ITEM"},
    {"category":"OTHER S&D COST"},
    {"category":"ADMIN MANAGEMENT & OTHER INDIRECT EXPENSE"},
    {"category":"DEMURRAGES"},
    {"category":"SALES COMMISSION"},
    {"category":"ANTI-DUMPING DUTY"},
    {"category":"LOCAL FREIGHT"},
    {"category":"OCEAN FREIGHT USA"},
    {"category":"BUILDING, CREDIT & VEHICLE INSURANCE & TAXES"},
    {"category":"DEPRECIATION"},
    {"category":"FINANCE COST"},
    {"category":"ELECTRICAL, MECHANICAL, CIVIL REPAIR & MAINTENANCE"},
    {"category":"QC COST"},
    {"category":"SOLAR UNITS GENERATED VALUE"},
    {"category":"ELECTRICITY & FUEL COST"},
    {"category":"PROCESSING CHARGES"},
    {"category":"PROCUREMENT COST"},
    {"category":"FINISHED GOODS MATERIAL TRANSFER COST"},
    {"category":"SALES DISCOUNTS (CHINA & UAE)"},
    {"category":"TMA INCENTIVE"},
    {"category":"OTHER INCOME"}
  ];
  
  

  const importExcel = (file: any[]) => {
    var data = new Uint8Array(file);
    var wb = XLSX.read(data, { type: 'array', cellDates: true });
    let sheet: any[] = [];
    for (const Sheet in wb.Sheets) {
      if (Sheet) {
        if (wb.Sheets.hasOwnProperty(Sheet)) {
          sheet.push(
            XLSX.utils.sheet_to_json(wb.Sheets[Sheet], { raw: true, header: 1 })
          );
        }
      }
    }
    return sheet;
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'text/csv') {
      setSelectedFile(event.target.files[0]);
      Papa.parse(event.target.files[0], {
        header: true,
        complete: function (result) {
          {
            const columnArray = [];
            const valueArray = [];

            result.data.map((d) => {
              columnArray.push(Object.keys(d));
              valueArray.push(Object.values(d));
            });
            setData(result.data);
            setColumns(columnArray[0]);
            setValues(valueArray);
          }
        },
        skipEmptyLines: true,
      });
    } else if (
      file &&
      file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      setSelectedFile(event.target.files[0]);
      let csvData;
      var reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = async (data) => {
        let csvData1: any = reader.result;
        csvData = importExcel(csvData1);

        const filteredNestedData = csvData.filter((innerData) =>
          innerData.some((row) => row.length > 0)
        );

        const output = filteredNestedData.map((innerData) => {
          const header = innerData[0];
          return innerData
            .slice(1)
            .map((row) => {
              if (row.every((value) => value === '')) {
                return null;
              }
              return row.reduce((acc, value, index) => {
                acc[header[index]] = value;
                return acc;
              }, {});
            })
            .filter((row) => row !== null);
        });
        setData(output[0]);
      };
    } else {
      alert('Please select a valid .csv file.');
      setSelectedFile(null);
    }
  };

  const handleUpload = async () => {
    try {
      form.validateFields().then(async () => {

        console.log(data,"999")
        const req = new ExpensesModelDtoReq(data,plantId)
        const res = await service.UploadExcel(req).then((res) => {
          setLoading(true);
          if (res.status) {
            AlertMessages.getSuccessMessage(res.internalMessage);
            history.push('/Finance-expenses-view');
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        });
      });
    } catch (error) {
      AlertMessages.getErrorMessage(error.message);
    }
  };

  let i = 1;
  const exceldata = [
    

    {
      title: 'SNo',
      dataIndex: 'sno',
      render: (text, object, index) => { return i++}
    },

    
    {
      title: 'Head',
      dataIndex: 'head',
     
    },
    {
      title: 'Category',
      dataIndex: 'category',
      render: (text: any, record: any) => {
        return record.category ? record.category : '-';
      },
    },
    {
      title: 'Month',
      dataIndex: 'month',
    
    },
    {
      title: 'Year',
      dataIndex: 'year',
      
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
     
    },
    {
      title: 'Type',
      dataIndex: 'type',
     
    },
  ];

  const exportExcel = () => {
    const excel = new Excel();
    excel
      .addSheet('Expenses Excel')
      .addColumns(exceldata)
      .addDataSource(expenseArray)
      .saveAs('Finance_Expenses.xlsx');
  };

  return (
    <Card
      title="Expenses"
      extra={
        <Link to="/Finance-expenses-view">
          <span style={{ color: 'white' }}>
            <Button type={'primary'}>View</Button>{' '}
          </span>
        </Link>
      }
    >
      <Form>
        <Row gutter={24}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
          >
            <Form.Item label="">
              <input
                type="file"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                onChange={handleFileChange}
              />
              <label style={{ color: 'blue', whiteSpace: 'nowrap' }}>
                Only csv & excel files are allowed
              </label>
            </Form.Item>
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
          >
            <Button
              type="primary"
              onClick={handleUpload}
              loading={loading}
              disabled={!selectedFile}
            >
              Upload
            </Button>
          </Col>
          <Button
            type="default"
            style={{ color: 'green' }}
            onClick={exportExcel}
            icon={<FileExcelFilled />}
          >
            Sample Format
          </Button>
        </Row>
      </Form>
    </Card>
  );
};

export default FinanceExpenses;
